import React from 'react';
import { Navigate } from 'react-router-dom';

// Lazy load components
const Settings = React.lazy(() => import('../pages/Settings'));
const NewFeatures = React.lazy(() => import('../pages/NewFeatures/NewFeatures'));
const NewFeatureDetails = React.lazy(() => import('../pages/NewFeatures/NewFeatureDetails'));
const AddNewFeature = React.lazy(() => import('../pages/NewFeatures/AddNewFeature'));
const NewFeaturesApplication = React.lazy(() => import('../pages/NewFeatures/NewFeaturesApplication'));
const PageNotFound = React.lazy(() => import('../pages/PageNotFound'));

export const getMiscRoutes = (loggedIn, portalUserLoggedIn, loginRedirect = '/login') => [
  {
    path: '/settings',
    element: loggedIn
      ? <Settings />
      : <Navigate to={loginRedirect} replace />
  },
  {
    path: '/new-features',
    element: loggedIn || portalUserLoggedIn
      ? <NewFeatures />
      : <Navigate to={loginRedirect} replace />,
    children: [
      {
        path: 'feature-details/:id',
        element: loggedIn || portalUserLoggedIn
          ? <NewFeatureDetails />
          : <Navigate to={loginRedirect} replace />
      },
      {
        path: 'suggest-feature',
        element: loggedIn || portalUserLoggedIn
          ? <AddNewFeature />
          : <Navigate to={loginRedirect} replace />
      }
    ]
  },
  {
    path: '/new-features-app',
    element: loggedIn || portalUserLoggedIn
      ? <NewFeaturesApplication />
      : <Navigate to="/login-app" replace />,
    children: [
      {
        path: 'feature-details/:id',
        element: loggedIn || portalUserLoggedIn
          ? <NewFeatureDetails />
          : <Navigate to="/login-app" replace />
      },
      {
        path: 'suggest-feature',
        element: loggedIn || portalUserLoggedIn
          ? <AddNewFeature />
          : <Navigate to="/login-app" replace />
      }
    ]
  },
  {
    path: '*',
    element: <PageNotFound />
  }
];

